var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "reset" } }, [
    _c("h2", [_vm._v("パスワードリセット")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.result,
            expression: "result"
          }
        ]
      },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.success,
                expression: "!success"
              }
            ]
          },
          [
            _c("p", { staticClass: "has-text-danger" }, [
              _vm._v(_vm._s(_vm.errMsg))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.success,
                expression: "success"
              }
            ]
          },
          [
            _c("p", { staticClass: "has-text-success" }, [
              _vm._v(_vm._s(_vm.successMsg))
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.loading,
            expression: "loading"
          }
        ],
        staticClass: "lds-roller"
      },
      [
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div"),
        _c("div")
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading && _vm.main,
            expression: "!loading && main"
          }
        ]
      },
      [
        this.$route.query.token
          ? _c("div", [
              _c(
                "section",
                [
                  _c(
                    "b-field",
                    { attrs: { horizontal: "", label: "新しいパスワード" } },
                    [
                      _c("b-input", {
                        attrs: { type: "password", maxlength: "50" },
                        model: {
                          value: _vm.password,
                          callback: function($$v) {
                            _vm.password =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "password"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      on: {
                        click: function($event) {
                          _vm.exec_reset()
                        }
                      }
                    },
                    [_vm._v("送信")]
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !this.$route.query.token
          ? _c("div", [
              _c(
                "section",
                [
                  _c("p", [
                    _vm._v("ユーザー登録時のメールアドレスを入力してください")
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-field",
                    { attrs: { horizontal: "", label: "メールアドレス" } },
                    [
                      _c("b-input", {
                        attrs: { type: "email", maxlength: "50" },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "button is-primary",
                      on: {
                        click: function($event) {
                          _vm.exec_prepare()
                        }
                      }
                    },
                    [_vm._v("送信")]
                  )
                ],
                1
              )
            ])
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6766c9cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6766c9cf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reset.vue
// module id = null
// module chunks = 